import React from 'react';

const Rules = ({ setCurrentView }) => (
    <div id="rulesView" className="info-container">
        <h2>Правила сервиса</h2>
        <p>Пожалуйста, внимательно ознакомьтесь с правилами нашего сервиса перед тем, как продолжить.</p>
        <ol>
            <li><strong>Покупка USDT</strong>
                <ul>
                    <li>Покупка USDT осуществляется у лиц строго старше 18 лет. </li>
                    <li>Запрещено оплачивать с карт 3-х лиц. </li>
                    <li>Оплачивать строго на указанные реквизиты.</li>
                </ul>
            </li>
            <li><strong>Продажа USDT</strong>
                <ul>
                    <li>При продаже на рекзититы 3-х лиц, обязательно получатель должен быть на связи. </li>
                    <li>Минимальная сумма продажи 300 usdt, платежи меньшей суммы обработаны не будут. </li>
                    <li>Максимальная сумма 10.000 usdt, платежи меньшей суммы обработаны не будут. </li>
                </ul>
            </li>
            <li><strong>Обмен юаня:</strong>
                <ul>
                    <li>Оплачивать строго на указанные реквизиты указанную сумму. При отправке по неверным реквизитам мы отвественности н несем.</li>
                    <li>После того как вам отправили реквизиты, оплатить нужно в течении 10 минут. </li>
                    <li>После перевода денег отправьте менеджеру QR-код от алипэй, юани будут зачислены в течении 5-15 минут.</li>
                </ul>
            </li>
        </ol>
        <p>Продолжая использовать наш сервис, вы подтверждаете, что прочитали, поняли и полностью согласны с настоящими правилами.</p>
        <button type="button" onClick={() => setCurrentView('previous')}>Назад</button>
    </div>
);

export default Rules;
